import ReactLoading from 'react-loading';
import { useTheme } from '@emotion/react';

type SpinnerProps = {
  testId?: string | null;
  color?: string | null;
  className?: string;
  size?: number;
};

type ThemeProps = {
  buttonTextColor: string;
};

export const Spinner = ({
  testId = null,
  color = null,
  className,
  size = 25,
}: SpinnerProps) => {
  const theme = useTheme() as ThemeProps;
  return (
    <ReactLoading
      data-testid={testId}
      className={className}
      type="spin"
      color={color || theme.buttonTextColor}
      height={size}
      width={size}
      delay={0}
    />
  );
};
